
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/mit-app-inventor-for-kids",
      function () {
        return require("private-next-pages/courses/mit-app-inventor-for-kids.tsx");
      }
    ]);
  